import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatasheetType } from '../../insights-data.enums';
@Component({
  selector: 'app-enter-data-heading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './enter-data-heading.component.html',
  styleUrl: './enter-data-heading.component.scss',
})
export class EnterDataHeadingComponent {
  @Input() selectedUnit = 1;
  dataSheetType = DatasheetType;
}
